import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorsComponent } from '../errors/errors.component';
import {
  MatInputModule, MatChipsModule, MatTooltipModule, MatButtonModule, MatStepperModule, MatMenuModule,
  MatToolbarModule, MatIconModule, MatCardModule, MatFormFieldModule, MatDatepickerModule, MatNativeDateModule,
  MatRadioModule, MatSelectModule, MatOptionModule, MatSlideToggleModule,
  MatTableModule, MatProgressBarModule, MatCheckboxModule, MatProgressSpinnerModule, MatExpansionModule, MatTabsModule
} from '@angular/material';
@NgModule({
  imports: [
    CommonModule,
     MatInputModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatCardModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatSelectModule,
    MatOptionModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatChipsModule,
    MatTabsModule
  ],
  declarations: [ErrorsComponent],
  exports:[ErrorsComponent,
   MatInputModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatCardModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatSelectModule,
    MatOptionModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatChipsModule,
    MatTabsModule

  ]
})
export class SharedModule { }
